import { createContext, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PreviousPathContext = createContext(null);

export function PreviousPathProvider({ children }) {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    prevPathRef.current = location.pathname;
  }, [location.pathname]);

  return (
    <PreviousPathContext.Provider value={prevPathRef.current}>
      {children}
    </PreviousPathContext.Provider>
  );
}